import { refinementList } from "instantsearch.js/es/widgets";
import { customizedCheckbox } from "./search_html_helpers";

const accountTypeRefinementWidget = () =>
  refinementList({
    container: "#account-type-refinement",
    operator: "and",
    attribute: "account_type",
    cssClasses: { list: "list-unstyled" },
    templates: { item: customizedCheckbox },
  });

export default accountTypeRefinementWidget;
